export default "__VITE_ASSET__CZUiS3iH__"